import React from "react";
import PropTypes from "prop-types";
import I18n from "lib/i18n";

const CommonMenuEntries = ({ user }) => (
  <React.Fragment>
    <li className="profile">
      <a href={`/profiles/${user.id}`}>{I18n.t("top_bar.label.profile")}</a>
    </li>

    <li className="sign-out">
      <a href="/sign_out">{I18n.t("top_bar.label.sign_out")}</a>
    </li>
  </React.Fragment>
  );

CommonMenuEntries.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default CommonMenuEntries;
